export default __webpack_public_path__ + "static/media/image.clover-partners.513d2ca1.png";